import { Box } from '@mui/material'
import styles from './Spinner.module.sass'

const Spinner = ({ sx }: { sx?: any }) => {
  return (
    <Box sx={sx} className={styles.spinnerBox}>
      <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 247 219" width="150" height="150">
        <defs>
          <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="2" result="blur" />
            <feComposite in="SourceGraphic" in2="blur" operator="over" />
          </filter>
          
          <linearGradient id="scanGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#4fbfd6" stopOpacity="0.1" />
            <stop offset="50%" stopColor="#4fbfd6" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#4fbfd6" stopOpacity="0.1" />
            <animate attributeName="x1" from="-100%" to="100%" dur="2s" repeatCount="indefinite" />
            <animate attributeName="x2" from="0%" to="200%" dur="2s" repeatCount="indefinite" />
          </linearGradient>
          
          <mask id="scanMask">
            <path fill="white" d="m142.4 59.9h-40.9l-28.6 51.2 24 45.2v-26.4l5.3-10.1 31.5-0.5-8.6-16.6h-18.2l15-28.9 25 48.3 0.1 31.8 24-42.8z"/>
          </mask>
        </defs>
        
        <style>
          {`
            @keyframes fadeInOut {
              0%, 100% {
                opacity: 0.2;
              }
              50% {
                opacity: 0.6;
              }
            }
            
            @keyframes scan {
              0% {
                y: 60;
                height: 5;
              }
              50% {
                height: 15;
              }
              100% {
                y: 154;
                height: 5;
              }
            }
            
            @keyframes gridPulse {
              0%, 100% {
                opacity: 0.1;
              }
              50% {
                opacity: 0.3;
              }
            }
            
            .logo-fill {
              fill: #1a2233;
              stroke: #8fd6e7;
              stroke-width: 1.5;
            }
            
            .scan-area {
              fill: url(#scanGradient);
              filter: url(#glow);
            }
            
            .scan-line {
              stroke: #8fd6e7;
              stroke-width: 1;
              stroke-dasharray: 5 3;
            }
            
            .grid-line {
              stroke: #8fd6e7;
              stroke-width: 0.5;
              opacity: 0.1;
            }
            
            .target-point {
              fill: #8fd6e7;
              filter: url(#glow);
            }
          `}
        </style>
        
        {/* Solid logo background */}
        <path className="logo-fill" d="m142.4 59.9h-40.9l-28.6 51.2 24 45.2v-26.4l5.3-10.1 31.5-0.5-8.6-16.6h-18.2l15-28.9 25 48.3 0.1 31.8 24-42.8z" />
        
        {/* Grid pattern */}
        <g mask="url(#scanMask)" className="grid-pattern">
          <line x1="73" y1="60" x2="73" y2="160" className="grid-line">
            <animate attributeName="opacity" values="0.1;0.3;0.1" dur="3s" repeatCount="indefinite" />
          </line>
          <line x1="93" y1="60" x2="93" y2="160" className="grid-line">
            <animate attributeName="opacity" values="0.1;0.3;0.1" dur="3s" repeatCount="indefinite" begin="0.3s" />
          </line>
          <line x1="113" y1="60" x2="113" y2="160" className="grid-line">
            <animate attributeName="opacity" values="0.1;0.3;0.1" dur="3s" repeatCount="indefinite" begin="0.6s" />
          </line>
          <line x1="133" y1="60" x2="133" y2="160" className="grid-line">
            <animate attributeName="opacity" values="0.1;0.3;0.1" dur="3s" repeatCount="indefinite" begin="0.9s" />
          </line>
          <line x1="153" y1="60" x2="153" y2="160" className="grid-line">
            <animate attributeName="opacity" values="0.1;0.3;0.1" dur="3s" repeatCount="indefinite" begin="1.2s" />
          </line>
          <line x1="173" y1="60" x2="173" y2="160" className="grid-line">
            <animate attributeName="opacity" values="0.1;0.3;0.1" dur="3s" repeatCount="indefinite" begin="1.5s" />
          </line>
          
          <line x1="73" y1="70" x2="173" y2="70" className="grid-line">
            <animate attributeName="opacity" values="0.1;0.3;0.1" dur="3s" repeatCount="indefinite" />
          </line>
          <line x1="73" y1="90" x2="173" y2="90" className="grid-line">
            <animate attributeName="opacity" values="0.1;0.3;0.1" dur="3s" repeatCount="indefinite" begin="0.3s" />
          </line>
          <line x1="73" y1="110" x2="173" y2="110" className="grid-line">
            <animate attributeName="opacity" values="0.1;0.3;0.1" dur="3s" repeatCount="indefinite" begin="0.6s" />
          </line>
          <line x1="73" y1="130" x2="173" y2="130" className="grid-line">
            <animate attributeName="opacity" values="0.1;0.3;0.1" dur="3s" repeatCount="indefinite" begin="0.9s" />
          </line>
          <line x1="73" y1="150" x2="173" y2="150" className="grid-line">
            <animate attributeName="opacity" values="0.1;0.3;0.1" dur="3s" repeatCount="indefinite" begin="1.2s" />
          </line>
        </g>
        
        {/* Scanning area */}
        <rect x="73" y="60" width="100" height="5" className="scan-area">
          <animate attributeName="y" values="60;154;60" dur="4s" repeatCount="indefinite" />
          <animate attributeName="height" values="5;15;5" dur="4s" repeatCount="indefinite" />
        </rect>
        
        {/* Scanning lines */}
        <line x1="73" y1="62.5" x2="173" y2="62.5" className="scan-line">
          <animate attributeName="y1" values="62.5;156.5;62.5" dur="4s" repeatCount="indefinite" />
          <animate attributeName="y2" values="62.5;156.5;62.5" dur="4s" repeatCount="indefinite" />
        </line>
        
        <line x1="73" y1="67.5" x2="173" y2="67.5" className="scan-line">
          <animate attributeName="y1" values="67.5;161.5;67.5" dur="4s" repeatCount="indefinite" />
          <animate attributeName="y2" values="67.5;161.5;67.5" dur="4s" repeatCount="indefinite" />
        </line>
        
        {/* Target points */}
        <circle cx="100" cy="80" r="1.5" className="target-point">
          <animate attributeName="opacity" values="0.5;1;0.5" dur="2s" repeatCount="indefinite" />
        </circle>
        
        <circle cx="130" cy="120" r="1.5" className="target-point">
          <animate attributeName="opacity" values="0.5;1;0.5" dur="2s" begin="0.7s" repeatCount="indefinite" />
        </circle>
        
        <circle cx="160" cy="90" r="1.5" className="target-point">
          <animate attributeName="opacity" values="0.5;1;0.5" dur="2s" begin="1.4s" repeatCount="indefinite" />
        </circle>
        
        {/* Scan target markers */}
        <rect x="95" y="75" width="10" height="10" fill="none" stroke="#8fd6e7" strokeWidth="0.5" strokeDasharray="2 1">
          <animate attributeName="opacity" values="0.3;1;0.3" dur="2s" repeatCount="indefinite" />
        </rect>
        
        <rect x="125" y="115" width="10" height="10" fill="none" stroke="#8fd6e7" strokeWidth="0.5" strokeDasharray="2 1">
          <animate attributeName="opacity" values="0.3;1;0.3" dur="2s" begin="0.7s" repeatCount="indefinite" />
        </rect>
        
        <rect x="155" y="85" width="10" height="10" fill="none" stroke="#8fd6e7" strokeWidth="0.5" strokeDasharray="2 1">
          <animate attributeName="opacity" values="0.3;1;0.3" dur="2s" begin="1.4s" repeatCount="indefinite" />
        </rect>
      </svg>
    </Box>
  )
}

export default Spinner